import { useCallback } from 'react';
import type { ProductCatalogSearchQueryOrderBy } from '@graphql/generated-base';
import { ProductCatalogAttributeSelectionType } from '@graphql/generated-base';
import { useFormattedRefinementFacetHref } from '../../hooks/useFormattedRefinementFacetHref/useFormattedRefinementFacetHref';
import { useHistory } from '@shared/core';
import type { OnFilterSelect } from '../RefinementFacet/RefinementFacet.types';
import { SORT_BY_CODE } from '../../Catalog.cache';
import { useCatalogLoggingContext } from '../../Catalog.logging';

export const useRefinementFacetList = () => {
  const history = useHistory();
  const { deriveHref, removeFilterFromHref } = useFormattedRefinementFacetHref();
  const { trackClickShopFilterCheckboxValue } = useCatalogLoggingContext();

  const handleOnFilterSelect = useCallback<OnFilterSelect>(
    ({ selectionType, filterArgs }) => {
      trackClickShopFilterCheckboxValue({ selectionType, filterArgs });
      switch (selectionType) {
        case ProductCatalogAttributeSelectionType.stringListMulti:
        case ProductCatalogAttributeSelectionType.priceBucket:
        case ProductCatalogAttributeSelectionType.priceRange:
          history.push(deriveHref(filterArgs));
          break;

        default:
          break;
      }
    },
    [history, deriveHref, trackClickShopFilterCheckboxValue],
  );

  const handleOnSortBy = useCallback(
    (sortBy: ProductCatalogSearchQueryOrderBy) => {
      history.push(deriveHref({ compositeCode: SORT_BY_CODE, value: sortBy }));
    },
    [deriveHref, history],
  );

  const removeFilterGroup = useCallback(
    (filterName: string) => {
      const href = removeFilterFromHref(filterName);
      history.push(href);
    },
    [history, removeFilterFromHref],
  );

  return { handleOnFilterSelect, removeFilterGroup, handleOnSortBy };
};
